export default __webpack_public_path__ + "52892d9babad40a8e48435ea2cf83594.png";